import { SITEWIDE_ERRORS } from "@sitewide/api/constants";
import { type SitewideResponse } from "@sitewide/api/types";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";

import { MUTATION_OPTIONS, getJSON } from "@/utils/swr";

const API_URL = `${import.meta.env.VITE_API_HOST}/api/sitewide`;

const searchSitewide = getJSON<SitewideResponse>(
  SITEWIDE_ERRORS.GENERIC_ERROR,
  {
    transformUrl: (url: string, payload: { arg: { prefix: string } }) =>
      `${url}?prefix=${payload.arg}`,
  },
);

export const useSitewideQuery = (
  onSuccess?: (results: SitewideResponse) => void,
) => {
  const { data } = useSWR(API_URL);

  const { trigger, error, isMutating } = useSWRMutation(
    API_URL,
    searchSitewide,
    {
      ...MUTATION_OPTIONS,
      onSuccess,
    },
  );

  return {
    results: data?.data,
    searchSitewide: trigger,
    sitewideError: error || !!data?.errors.at(0),
    isSearchingSitewide: isMutating,
  };
};
